module.exports = "<p>\n  postular-proyecto works!\n</p>\n"